import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Table, Form, } from 'react-bootstrap'

import { addICUAdmissionOrganSupport } from '../reducers/antibioticsUseFormReducer'


import ICUAdmissionOrganSupport from './ICUAdmissionOrganSupport'


const ICUAdmissionOrganSupportTable = (props) => {

  const [selected, setSelected] = useState("-")

  const organSupportOptions = [
    'Mechanical ventilation',
    'Continuous renal replacement therapy',
    'ECMO',
    'Use of Vasopressor Medication',
    'Other',
  ]

  const organSupportsThatHaveNotBeenSelected = organSupportOptions.filter(option => {
    return !props.organ_supports.find(support => support.name === option)
  })

  const handleSelect = (e) => {
    let { value } = e.target
    if (value === 'Other') {
      value = ''
    }

    props.addICUAdmissionOrganSupport(props, props.organ_supports.length + 1, value)
    return setSelected("-")
  }


  return (
    <div className='indented-row'>
      {props.organ_supports && props.organ_supports.length > 0 ?
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <Table striped bordered responsive>
              <thead>
                <tr>
                  {props.chartForReview ?
                    null
                    :
                    <th></th>
                    }
                  <th>
                    Type
                  </th>

                  <th>
                    Start Date
                  </th>

                  <th>
                    End Date
                  </th>

                  <th>
                    Reason
                  </th>
                </tr>
              </thead>

              <tbody>
                {props.organ_supports.map(organSupport => {
                  const showNameAsForm = !organSupportOptions.includes(organSupport.name) || organSupport.name === 'Other'
                  return (
                    <ICUAdmissionOrganSupport
                      key={organSupport.id}
                      chartForReview={props.chartForReview}
                      icuAdmissionId={props.icuAdmissionId}
                      organ_supports={props.organ_supports}
                      showNameAsForm={showNameAsForm}
                      {...organSupport}
                    />
                  )
                })}
              </tbody>
            </Table>
          </Col>
        </Row>
        :
        null
      }

      {props.chartForReview ?
        null
        :
        <Row>
          <Col xs={12} sm={12} md={6} lg={6}>
            <Form.Control
              as="select"
              value={selected}
              onChange={handleSelect}
              required={true}
            >
            <option value={"-"}>
              Add organ support
            </option>
            {organSupportsThatHaveNotBeenSelected.map(choice => {
              return (
                <option
                  key={choice}
                  value={choice}
                >
                  {choice}
                </option>
              )
            })}
           </Form.Control>
          </Col>
        </Row>
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    // additionalAntimicrobials: state.antibioticsUseFormReducer.additionalAntimicrobials,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addICUAdmissionOrganSupport: (props, name, number) => {
      dispatch(addICUAdmissionOrganSupport(props, name, number))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ICUAdmissionOrganSupportTable)
